/**
 * This file reads end point from Splitter
 */
export default {
    getSplitterURL() {
        return WP_SPLITTER_URL;
    },
};
